var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("custom-dasboard", {
        ref: "customDashboard",
        attrs: { "is-mobile": _vm.isMobile, sections: _vm.sections }
      }),
      _c("immediate-message-popup", {
        ref: "_immediateMessagePopupRef",
        attrs: { id: "immediateMessagePopup", items: _vm.immediateMessages },
        on: { "message-marked-as-read": _vm.markMessageAsRead }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }